import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchQuestions = createAsyncThunk('fetchQuestions', async (tag)=>{
    // console.log(tag);
    const response = await axios.get(`/questions/${tag}`);
    return response.data;
})

const fetchQuestionsSlice = createSlice({
    name: 'CurrentQuestions',
    initialState: {
        isLoading: false,
        data: [],
        isError: false
    },
    extraReducers: (builder)=>{
        builder.addCase(fetchQuestions.pending, (state, action)=>{
            state.isLoading = true;
        })
        builder.addCase(fetchQuestions.fulfilled, (state, action)=>{
            state.isLoading = false;
            state.data = action.payload;
        })
        builder.addCase(fetchQuestions.rejected, (state, action)=>{
            console.log('Error', action.payload);
            state.isError = true;
        })
    }
})
export default fetchQuestionsSlice.reducer;